import { FormEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { database } from '../services/firebase';
import { Button } from '../components/Button';
// import { useTheme } from '../hooks/useTheme';
import toast, { Toaster } from 'react-hot-toast';

import entryImg from '../assets/images/Button/log-in.svg';
import illustrationImg from '../assets/images/Illustration.svg';
import logoImg from '../assets/images/Logo.svg';
import googleIconImage from '../assets/images/Button/google.svg';
import '../styles/auth.scss';

export function Home() {
  const history = useHistory();
  const { user, signInWithGoogle } = useAuth();
  const [roomCode, setRoomCode] = useState('');
  // const { theme, toggleTheme } = useTheme();

  async function handleCreateRoom() {
    if (!user) {
      await signInWithGoogle();
    }
    history.push('/rooms/new');
  }

  async function handleJoinRoom(event: FormEvent) {
    event.preventDefault();

    if (roomCode.trim() === '') {
      return toast('The field with the code room is empty', { icon: '⚠️' });
    }

    const roomRef = await database.ref(`rooms/${roomCode}`).get();

    if (!roomRef.exists()) {
      return toast('Room does not exists.', { icon: '⚠️' });
    }

    if (roomRef.val().closedAt) {
      return toast('Room already closed.', { icon: '⚠️' });
    }

    history.push(`/rooms/${roomCode}`);
  }

  return (
    // className={theme}
    <div id="page-auth">
      <aside>
        <img src={illustrationImg} alt="Ilustração simbolizando perguntas e respostas" />
        <strong>Crie salas de Q&amp;A ao vivo</strong>
        <p>Tire as dúvidas da sua audiência em tempo-real</p>
      </aside>
      <main>
        <div className="main-content">
          <img src={logoImg} alt="Letmeask" />
          <Toaster toastOptions={{ className: "dark-toast" }} />
          <button className="create-room" onClick={handleCreateRoom}>
            <img src={googleIconImage} alt="Logo do Google" />
            Crie sua sala com o Google
          </button>
          <div className="separator">ou entre em uma sala</div>
          <form onSubmit={handleJoinRoom}>
            <input
              type="text"
              placeholder="Digite o código da sala"
              onChange={event => setRoomCode(event.target.value)}
              value={roomCode}
            />
            <Button type="submit">
              <img src={entryImg} alt="Logo Entrar" />
              Entrar na sala
            </Button>
          </form>
          {/* <Button className="button mt" onClick={toggleTheme}>Mudar Tema</Button> */}
        </div>
      </main>
    </div>
  );
}